import { trace } from 'rytm-helpers'
import imagesLoaded from 'imagesloaded'

const IMAGE_FULL_WRAPPER_SELECTOR = ".amzn-image-full"

export const initImgFull = () => {
  document.addEventListener("click", onDocumentClick)
}
export const closeImgFull = () => {
  const wrapper = getImageFullWrapper()
  if (wrapper) {
    wrapper.classList.remove('show')
    wrapper.innerHTML = ''
  }
  removeEventListeners()
}

// add event listeners on open
const addEventListeners = () => {
  document.addEventListener("click", onOpenDocumentClick)
}
const removeEventListeners = () => {
  document.removeEventListener("click", onOpenDocumentClick)
}


// ## DOM events
const onDocumentClick = (e) => {
  if (e.target.matches('[data-image-full]')) {
    const src = e.target.dataset.imageFull
    const wrapper = getImageFullWrapper()
    if (src && wrapper) {
      e.preventDefault()
      openImageFull(src)
      addEventListeners()
    }
  }
}
// on click when opened
const onOpenDocumentClick = (e) => {
  e.preventDefault()
  closeImgFull()
}


// Helpers
const getImageFullWrapper = () => {
  return document.querySelector(IMAGE_FULL_WRAPPER_SELECTOR)
}

const openImageFull = (src) => {
  const wrapper = getImageFullWrapper()
  if (src && wrapper) {
    document.documentElement.classList.add('image-full-loading')
    const img = document.createElement('img')
    imagesLoaded(img, () => {
      document.documentElement.classList.remove('image-full-loading')
      wrapper.appendChild(img)
      centerWrapperScrollPosition(wrapper)
      wrapper.classList.add('show')
    })
    img.src = src
  }
}
// set wrapper scroll position to center image
const centerWrapperScrollPosition = (wrapper) => {
  const img = wrapper.querySelector('img')
  if (img) {
    const imgHeight = img.offsetHeight
    const wrapperHeight = wrapper.offsetHeight
    const wrapperWidth = wrapper.offsetWidth
    const scrollTop = (imgHeight - wrapperHeight) / 2
    const scrollLeft = (img.offsetWidth - wrapperWidth) / 2
    wrapper.scrollTop = scrollTop
    wrapper.scrollLeft = scrollLeft
  }
}